import { useUnreadCount } from '../hook/useUnreadCount';

/**
 * Mounts CometChat unread fetch + message listener once for the whole authenticated
 * session. Keeps the listener attached across route changes and Messenger open/close.
 */
export default function CometChatUnreadSync() {
    useUnreadCount();
    return null;
}
